import React from 'react';
import type ServicedeskKbRequestsReportsType from '@atlassian/jira-spa-apps-servicedesk-kb-requests-reports/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskKbRequestsReports = lazyForPaint<
	typeof ServicedeskKbRequestsReportsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-kb-requests-reports", jiraSpaEntry: "async-servicedesk-kb-requests-reports" */ '@atlassian/jira-spa-apps-servicedesk-kb-requests-reports'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ match }: RouteContext) => {
	const reportType = match.params.reportType || '';
	return (
		<LazyPage
			Page={LazyServicedeskKbRequestsReports}
			pageId={`spa-apps/servicedesk/reports/${reportType}`}
			shouldShowSpinner
		/>
	);
};
